module.exports = __webpack_public_path__ + "static/assets/c304e6cc2ad622167b6ef46e30cc9423.png";